module.exports = require("componentry");